var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { Box, Typography } from '@pocketlaw/tetris';
import { PopButtonContainer, PopButtonContent } from './styled';
export const PopButton = forwardRef((props, ref) => {
    const { icon, label, disabled, onClick } = props, rest = __rest(props, ["icon", "label", "disabled", "onClick"]);
    return (<PopButtonContainer disabled={disabled} onClick={onClick} ref={ref} {...rest}>
      <PopButtonContent>
        <Box flexDirection="column" gap="lg">
          {icon}
          <Typography $fontSize="small" $fontWeight="semibold">
            {label}
          </Typography>
        </Box>
      </PopButtonContent>
    </PopButtonContainer>);
});
